module.exports = require("././src/scripts/ng-notify.js");
require("././src/styles/ng-notify.css");


//////////////////
// WEBPACK FOOTER
// ng-notify (bower component)
// module id = 994
// module chunks = 1